import { render, staticRenderFns } from "./Decimal.vue?vue&type=template&id=6b8ba486&"
import script from "./Decimal.vue?vue&type=script&lang=js&"
export * from "./Decimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QSelect,QInput} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSelect,QInput})
